// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir] .background-401 {\n  background-image: url(\"https://s3.amazonaws.com/archivos.febos.io/publico/portales/narvi/Fondo_Keynote_03.jpg\");\n}\n.info {\n  color: #ffffff;\n}\n[dir] .info {\n  padding: 30px;\n  margin-top: 30px;\n  text-shadow: 0 0 30px #000000;\n}", ""]);
// Exports
module.exports = exports;
